enum Rules {
    NEVER = 'never',
    EMPTY = 'empty',
    ALWAYS = 'always',
}

type Rule = Rules.NEVER | Rules.EMPTY | Rules.ALWAYS;

export interface HomeSecurity extends SettingsSecurity {
    homeId: string;
}

export interface SettingsSecurity {
    gone_after: number;
    share_info: boolean;
    smart_notifs: boolean;
    events_ttl: EventFrequency;
    NACamera?: SettingsNACamera;
    NDB?: { notify_humans: Rule, record_humans: Rule };
    NOC?: SettingsNOC;
}

export interface SettingsNACamera {
    notify_movements: Rule;
    record_alarms: Rule;
    record_animals: Rule;
    record_movements: Rule;
    notify_unknowns: Rule;
    record_humans: Rule;
    notify_humans: Rule;
    notify_animals: Rule;
    siren_sound_unknowns: Rule;
    siren_sound_movements: Rule;
    siren_sound_animals: Rule;
    siren_sound_humans: Rule;
}

export interface SettingsNOC {
    record_movements: Rule;
    notify_movements: Rule;
    record_humans: Rule;
    notify_humans: Rule;
    record_animals: Rule;
    notify_animals: Rule;
    record_vehicles: Rule;
    notify_vehicles: Rule;
    notification_begin: number;
    notification_end: number;
    enable_notification_range: Rule;
}
export interface HomesSecurityState {
    homesSecurity: HomeSecurity [];
}

export enum EventFrequencies {
    TWO_DAYS = 'two_days',
    ONE_WEEK = 'one_week',
    ONE_MONTH = 'one_month',
    THREE_MONTHS = 'three_months',
    ONE_YEAR = 'one_year',
    NEVER = 'never',
}

type EventFrequency =
    EventFrequencies.TWO_DAYS |
    EventFrequencies.ONE_WEEK |
    EventFrequencies.ONE_MONTH |
    EventFrequencies.THREE_MONTHS |
    EventFrequencies.ONE_YEAR |
    EventFrequencies.NEVER;
